const TermsConditions = () => (
  <div style={{ padding: '2rem', lineHeight: 1.6 }}>
    <h1>利用規約</h1>
    <p>最終更新日: 2025年11月7日</p>
    <p>
      本サービスをご利用いただくにあたり、以下の利用規約に同意いただく必要があります。
      本規約は、ユーザーと当社との間の権利義務関係を定めるものです。
    </p>
    <p>Test</p>
  </div>
);

export default TermsConditions;
